import React, { useMemo } from 'react';

import { FiTrash } from 'react-icons/fi';

import { Box, Typography, IconButton } from '@material-ui/core';
import { ButtonCount } from 'components';

import useStyles from './styles';

import restaurantNotFoundImg from 'assets/images/logoMenuShop.svg';
import { formatMoney } from 'helpers/moneyFormatter';

const ProductItem = ({ index, product, onUpdateAmount, onRemoveProduct }) => {
  const classes = useStyles();

  const productPrice = useMemo(() => {
    const { cart } = product;

    if (!cart.product_options_request_products.length) {
      return product.price * cart.amount;
    }

    const additionalPrice = cart.product_options_request_products.reduce(
      (acc, aditional) => {
        return acc + aditional.price;
      },
      0,
    );

    return (product.price + additionalPrice) * cart.amount;
  }, [product]);

  const handleUpdateAmount = (amount) => {
    onUpdateAmount(amount, index);
  };

  const handleRemoveProduct = () => {
    onRemoveProduct(index);
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.mainContent}>
        <Box className={classes.productInfo}>
          <Box
            className={classes.image}
            style={{ backgroundImage: `url(${product.image})` }}
          >
            {!product.image && (
              <img
                src={restaurantNotFoundImg}
                width="100px"
                alt={product.name}
              />
            )}
          </Box>

          <Box className={classes.productDetails}>
            <Typography variant="subtitle1" className={classes.typographyName}>
              {product.name}
            </Typography>
            <Typography variant="caption" display="block" gutterBottom>
              {formatMoney(product.price)} X {product.cart?.amount}
            </Typography>
            <Typography variant="subtitle2" className={classes.typographyPrice}>
              {formatMoney(productPrice)}
            </Typography>
          </Box>
        </Box>

        <Box className={classes.actions}>
          <Box className={classes.boxTrashIcon}>
            <IconButton size="medium" onClick={handleRemoveProduct}>
              <FiTrash color="#000" />
            </IconButton>
          </Box>

          <ButtonCount
            mt={0}
            count={product.cart?.amount || 0}
            setCount={handleUpdateAmount}
          ></ButtonCount>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductItem;
